import { Controller } from "stimulus"

// Shows/hides one or more fields depending on whether a paired checkbox/radio is checked.
// Put data-controller="conditionalCheckbox" on a container that wraps every
// trigger/field pair. Each trigger needs data-conditionalCheckbox-target="trigger",
// data-action="change->conditionalCheckbox#toggle" and data-reveals-field="<id>"
// (space-separated if a trigger reveals more than one field).
// Each field needs data-conditionalCheckbox-target="field" and data-reveal-field="<id>"
// (one of the ids listed by its trigger's data-reveals-field).
export default class extends Controller {
  static targets = ["trigger", "field"]

  connect() {
    this.triggerTargets.forEach((trigger) => this.sync(trigger))
  }

  toggle(event) {
    const trigger = event.currentTarget
    this.sync(trigger)

    // Radios in the same group don't fire their own change event when they become
    // unchecked, so re-sync siblings to keep complementary reveals in sync.
    if (trigger.type === "radio" && trigger.name) {
      this.triggerTargets
        .filter((candidate) => candidate !== trigger && candidate.name === trigger.name)
        .forEach((sibling) => this.sync(sibling))
    }
  }

  sync(trigger) {
    const fieldIds = (trigger.dataset.revealsField || "").split(/\s+/).filter(Boolean)
    if (fieldIds.length === 0) return

    const shouldShow = trigger.checked
    this.fieldTargets.forEach((field) => {
      if (!fieldIds.includes(field.dataset.revealField)) return

      field.classList.toggle("is-hidden", !shouldShow)
      field.querySelectorAll("input, textarea, select").forEach((input) => {
        input.disabled = !shouldShow
      })
    })

    // A document uploader that stays visible but is mandatory only while a field is revealed
    // (data-required-when-revealed="<id>").
    this.element.querySelectorAll("[data-required-when-revealed]").forEach((uploader) => {
      if (!fieldIds.includes(uploader.dataset.requiredWhenRevealed)) return

      uploader.dataset.conditionallyRequired = String(shouldShow)
      const controller = this.application.getControllerForElementAndIdentifier(uploader, "kycUpload")
      if (controller) controller.syncRequired()
    })
  }
}
